exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#layersJoinModal .v--modal-box.v--modal{min-height:375px!important;min-width:560px!important}#layersJoinModal *{font-size:12px}#layersJoinModal .checkbox--big i{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-317f2578","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/modals/LayersJoin.vue
// module id = 2147
// module chunks = 0